<template>
  <div class="view">

	<box>

		<table class="table-a">
			<thead>
				<tr>
					<th class="align-l"></th>
					<th class="align-l"></th>
					<th class="align-r">Total faktureret ift. tidstracking</th>
					<th class="align-r">%</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(user,user_i) in byUsers">
					<td>
						<avatar :input="user"></avatar>
					</td>
					<td class="align-l">{{user.first_name}}</td>
					<td class="align-r">{{outputMoney( user.billable_kr )}} kr.</td>
					<td class="align-r">{{user.billable_pct}} %</td>
				</tr>
				<tr>
					<td></td>
					<td></td>
					<td class="align-r">
						<b>{{outputMoney( allBudgetsTotal )}} kr.</b>
					</td>
					<td></td>
				</tr>
			</tbody>
		</table>

		<br>
		<p>
			<b>Udregning</b>
			<p>Brugerens projekter gennemgås. For hvert projekt aflæses brugerens andel af tid logget på projektet. Denne andel holdes op imod projektets samlede budget.</p>
		</p>
		<br>
		<p>Husk, at denne udregning kun tager højde for hvor mange timer brugerne har tracket, og ikke medberegner graden af effektivitet per time.</p>

	</box>

  </div>
</template>

<script>
import mixins from '../mixins.js';
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Avatar from '.././components/Avatar'
export default {
  name: 'clients',
  mixins: [ mixins.db, mixins.generic ],
  data: function () {
    return {
      globals: this.$parent.globals,
    }
  },
  computed:{

	allBudgetsTotal(){
		var output = 0
		var list = this.$store.state.firebase.projects
		if(!list) return output
		for( var project_key in list ) {
			if(project_key == '.key') continue // why, vuexfire?
			var project = list[project_key]
			output += this.getProjectBudgetTotal(project)
		}
		return output
	},

	byUsers(){
		var output = []
		
		var list = this.$store.state.firebase.users
		if(!list) return output
		
		for( var user_key in list ) {

			if(user_key == '.key') continue // why, vuexfire?
			var user = list[user_key]

			user.billable_kr = 0

			for( var project_key in this.$store.state.firebase.projects			 ) {

				if(project_key == '.key') continue // why, vuexfire?
				var project = this.$store.state.firebase.projects[project_key]

				var projectTimeloggedHours_by_user = this.readTimeloggedHours({ project_key: project['.key'], user_key: user['.key'] })
				var projectTimeloggedHours_total = this.readTimeloggedHours({ project_key: project['.key'] })

				var userTimeShare = ( projectTimeloggedHours_by_user / projectTimeloggedHours_total )
				if( isNaN(userTimeShare) ) userTimeShare = 0

				var projectBudget = this.getProjectBudgetTotal(project)

				var userBudgetShare = projectBudget * userTimeShare

				user.billable_kr += userBudgetShare
				
			}

			user.billable_pct = ( user.billable_kr / this.allBudgetsTotal ) * 100
			user.billable_pct = parseFloat(user.billable_pct).toFixed(0)


			output.push(user)
		}
		return output
	},

  },//computed
  methods: {

	readTimeloggedHours: helpers.readTimeloggedHours,
	getProjectBudgetTotal: helpers.getProjectBudgetTotal,
	getProjectHoursEstimate: helpers.getProjectHoursEstimate,
	getProjectAcceptedSpec: helpers.getProjectAcceptedSpec,
	outputMoney: helpers.outputMoney,

    goto(location){
      this.$router.push(location)
    },

  },//methods
  components: { Box, Btn, Avatar },
}
</script>



// WEBPACK FOOTER //
// Report_invoicability.vue?ba2d84bc